import React, { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import DNPTable from '../components/DNPTable'
import ReferralSourcesService from '../services/ReferralSourcesService'

export default withRouter(({ history }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [clients, setClients] = useState([])

  useEffect(() => {
    ReferralSourcesService.getAll()
      .then(data => {
        setClients(data)
        setIsLoading(false)
      })
      .catch(err => {
        setError(err.message)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center mt-2">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="container mt-2 pb-3">
      <Helmet title="Clients" />
      {!!error && (
        <Alert variant="danger" className="mb-4 pr-5 pl-5">
          <strong>Error:</strong> <pre className="mb-0">{error}</pre>
        </Alert>
      )}
      <div className="d-flex justify-content-end my-4">
        <a className="main-link" href={`/library/clients/add`}>
          Add Client
        </a>
      </div>
      <DNPTable
        items={clients}
        columns={[
          {
            title: 'Name',
            getText: client => <a href={`/library/clients/${client.id}`}>{client.name}</a>,
          },
          { title: 'Billing Name', getText: client => client.billingName },
          { title: 'Phone', getText: client => client.phone },
          { title: 'Email', getText: client => client.email },
        ]}
        noItemsText="No clients have been added"
      />
    </div>
  )
})
